// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Form_wrapper__2D4dZ","hint":"Form_hint__3mlhe","field":"Form_field__1YPo2","btn_wrapper":"Form_btn_wrapper__oP6pV","btn_submit":"Form_btn_submit__2qcN8"};